import { Injectable } from '@angular/core';
import { SelectInputsList } from '@portal/shared/helpers/src';
import { ISelectInput } from '@portal/shared/ui/filter';
import { FallbackModeType } from '../../../enums/fallback-mode.enum';

import sortBy from 'lodash-es/sortBy';

@Injectable()
export class FallbackModeList extends SelectInputsList {
  keyValue = {
    [FallbackModeType.ElectronicFallback]: $localize`:fallback mode|:Electronic Fallback`,
  };
  list: ISelectInput[] = sortBy(this.getSelectInputs(), ['text']);

  constructor() {
    super();
  }
}